<template>
  <SidebarComponent />
  <div class="dashboard-layout">
    <div class="content-container">
      <div class="card-container">
        <div class="titolo-card">
          <h1>Prenotazioni Coaching Day</h1>
        </div>

        <div class="loader" v-if="isLoading">
          <h4>Caricamento in corso...</h4>
        </div>
        <!-- Messaggio quando non ci sono prenotazioni da mostrare -->
        <div v-if="!bookings.length && !isLoading" class="no-bookings">
          <div class="card-image">
          <img src="https://www.metodofusco.it/media/COACHING_DAY.png" alt="Descrizione dell'immagine">
        </div>
              </div>
        <!-- Sezione per la selezione del prodotto -->
        <div>
          <select v-model="selectedProductId">
            <option v-for="product in products" :key="product.id" :value="product.id">{{ product.name }}</option>
          </select>
          <button @click="fetchBookings">Filtra per Coaching Day</button>
        </div>


        <div class="bookings" v-if="bookings.length">
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Data Inizio</th>
                <th>Data Fine</th>
                <th>Cliente</th>
                <th>Email</th>
                <th>Stato</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="booking in bookings" :key="booking.id">
                <td>{{ booking.id }}</td>
                <td>{{ formatDate(booking.start, booking.status) }}</td>
<td>{{ formatDate(booking.end, booking.status) }}</td>

                <td>{{ getOrderDetail(booking.order_id).customerName || 'N/D' }}</td>
                <td>{{ getOrderDetail(booking.order_id).customerEmail || 'N/D' }}</td>
                <td>{{ booking.status }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import SidebarComponent from '../SidebarComponent.vue';
import { initializeApp } from "firebase/app";
import { getFunctions, httpsCallable } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyDp3djBGu504OhM7uGg1jiA6MsC4ZWQszs",
  authDomain: "fusco-fit-connect-4b731.firebaseapp.com",
  databaseURL: "https://fusco-fit-connect-4b731-default-rtdb.firebaseio.com",
  projectId: "fusco-fit-connect-4b731",
  storageBucket: "fusco-fit-connect-4b731.appspot.com",
  messagingSenderId: "691335746060",
  appId: "1:691335746060:web:868eaf5af62d389727d429",
  measurementId: "G-FL6QKY34E9"
};
const app = initializeApp(firebaseConfig);
const functions = getFunctions(app);

export default {
  components: {
    SidebarComponent,
  },
  data() {
    return {
      bookings: [],
      orderDetails: {},
      isLoading: false,
      products: [], // Lista dei prodotti per il filtro
      selectedProductId: null, // Il prodotto selezionato dall'utente per il filtro
    };
  },
  methods: {
    async fetchProducts() {
      this.isLoading = true;
      try {
        // Sostituisci 'https://example.com' con il tuo dominio
        const response = await fetch('https://www.fusco.fit/wp-json/wc-bookings/v1/products', {
          headers: {
            'Authorization': 'Basic ' + btoa('your-username:your-password')
          }
        });
        if (!response.ok) {
          throw new Error('Errore nel recupero dei prodotti');
        }
        const products = await response.json();
        this.products = products;
      } catch (error) {
        console.error('Errore nel recupero dei prodotti:', error);
      } finally {
        this.isLoading = false;
      }
    },




    async fetchBookings() {
      if (!this.selectedProductId) {
        alert("Per favore, seleziona un prodotto.");
        return;
      }
      this.isLoading = true;
      try {
        const fetchBookingsFunction = httpsCallable(functions, 'fetchBookings');
        const result = await fetchBookingsFunction({ productId: this.selectedProductId });
        if (result.data.success) {
          // Ordina le prenotazioni basandoti sull'orario di inizio originale
          const sortedBookings = result.data.bookings.sort((a, b) => a.start - b.start);
          this.bookings = sortedBookings;
          await Promise.all(this.bookings.map(async (booking) => {
            await this.fetchOrderDetails(booking.order_id);
          }));
        } else {
          console.error('Errore nel recupero delle prenotazioni:', result.data.error);
        }
      } catch (error) {
        console.error('Errore nel recupero delle prenotazioni:', error);
      } finally {
        this.isLoading = false;
      }
    },


    formatDate(timestamp, status) {
  console.log(`Formatting date for status: ${status}`); // Aggiungi per debug
  const date = new Date(timestamp * 1000);
  let offsetInHours;
  switch (status) {
    case 'complete':
      offsetInHours = -2;
      break;
      case 'paid':
    case 'cancelled': // Gestisci 'cancelled' allo stesso modo di 'complete'
    case 'pending': // Gestisci 'cancelled' allo stesso modo di 'complete'

    offsetInHours = -2;
      break;
    default:
      offsetInHours = 0; // Nessun offset se lo stato non è riconosciuto
      break;
  }
  console.log(`Applying offset: ${offsetInHours}`); // Aggiungi per debug
  date.setHours(date.getHours() + offsetInHours);
  const optionsTime = { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false };
  const formattedTime = date.toLocaleTimeString('it-IT', optionsTime).slice(0, 5);
  return formattedTime;
},


 







    async fetchOrderDetails(orderId) {
      if (!orderId || this.orderDetails[orderId]) {
        return;
      }
      this.isLoading = true;
      try {
        const fetchOrderDetailsFunction = httpsCallable(functions, 'fetchOrderDetails');
        const result = await fetchOrderDetailsFunction({ orderId });
        if (result.data.success) {
          this.orderDetails[orderId] = {
            customerName: `${result.data.orderDetails.billing.first_name} ${result.data.orderDetails.billing.last_name}`,
            customerEmail: result.data.orderDetails.billing.email,
          };
        } else {
          console.error('Errore nel recupero dei dettagli dell\'ordine:', result.data.error);
        }
      } catch (error) {
        console.error('Errore nel recupero dei dettagli dell\'ordine:', error);
      } finally {
        this.isLoading = false;
      }
    },
    getOrderDetail(orderId) {
      return this.orderDetails[orderId] || {};
    },
  },
  async mounted() {
    this.fetchProducts();
  },
};
</script>